<template>
  <v-form v-model="formValid">
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-row>
            <!-- Selection de l'employe -->
            <v-col cols="12">
              <employe-autocomplete
                v-model="employe"
                label="Employé"
                :etablissement="etablissement"
                :required="create"
                :readonly="!create"
              />
            </v-col>
            <!-- Selection du type de congés -->
            <v-col cols="12">
              <v-select
                :items="congesTypes"
                v-model="congesDebit.type"
                item-text="label"
                item-value="type"
                label="Type de congés*"
                dense
                :rules="[(v) => !!v]"
                return-object
                :disabled="!exceptionnel"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col cols="12">
              <!-- Selection des dates -->
              <s-date-picker
                v-model="congesDebit.date"
                label="Date du débit"
                required
                defaultCurrent
                :disabled="!exceptionnel"
              />
            </v-col>
            <v-col cols="12">
              <!-- Selection des dates -->
              <s-date-picker
                v-model="congesDebit.dateExpiration"
                label="Date d'expiration"
                dense
                required
                :disabled="!exceptionnel"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="congesDebit.nbJours"
            :rules="numericFieldRule"
            hide-no-data
            type="number"
            label="Débités*"
            suffix="jour(s)"
            required
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="congesDebit.commentaire"
            no-resize
            rows="2"
            hide-no-data
            clearable
            clear-icon="mdi-close-circle"
            label="Commentaire"
          ></v-textarea>
        </v-col>
      </v-row>
      <small>*Information obligatoire</small>
    </v-container>
  </v-form>
</template>

<script>
import EmployeAutocomplete from '@/components/employe/employe-autocomplete'
import { mapGetters } from 'vuex'
import SDatePicker from '@/components/global/s-date-picker.vue'

export default {
  name: 'conges-debit-form',
  components: {
    SDatePicker,
    EmployeAutocomplete,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    create: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      formValid: false,
      congesDebit: undefined,
      numericFieldRule: [
        (v) => !!v || 'Information obligatoire',
        (v) => !isNaN(v) || 'Entrez une valeur numérique',
        (v) => v < 0 || 'Entrez une valeur négative',
      ],
    }
  },
  computed: {
    ...mapGetters({
      etablissement: 'application/getSelectedEtablissement',
      employes: 'employe/getEmployes',
      getEmployeById: 'employe/getEmployeById',
      getCongesTypes: 'conges/getCongesTypes',
    }),
    exceptionnel() {
      return this.congesDebit.exceptionnel
    },
    congesTypes() {
      return this.getCongesTypes.filter((t) => t.avecSolde)
    },
    employe: {
      get() {
        return this.getEmployeById(this.congesDebit.employeId)
      },
      set(_employe) {
        this.congesDebit.employeId = _employe.employeId
      },
    },
  },
  created() {
    this.congesDebit = this.value
  },
  watch: {
    congesDebit: {
      handler() {
        this.$emit('input', this.congesDebit)
      },
      deep: true,
    },
    value() {
      this.congesDebit = this.value
    },
    formValid() {
      this.$emit('updateFormValid', this.formValid)
    },
  },
}
</script>

<style scoped></style>
